export default __webpack_public_path__ + "static/media/secondary.c13cff933afdaeecf93d80175ddbe902.svg";